(ns net.kestec.mhda-pilgrimage.theme
  (:require
    ["@mui/material/styles" :refer [createTheme]]))




(def mhda-theme
  (createTheme (clj->js
                 {:colorSchemes {:light true
                                 :dark  true
                                 }
                  :palette      {
                                 :error {:main "#8b0000"}
                                 :primary {:main "#000093"}
                                 :secondary {:main "#8b0000"}
                                 }
                  :status       {:danger "red"}
                  :typography   {
                                 :h1                  {:fontSize   "2.0rem"
                                                       :fontWeight 900}
                                 :h2                  {:fontSize   "1.875rem"
                                                       :fontWeight "bold"}
                                 :h3                  {:fontSize   "1.45rem"
                                                       :fontWeight "bold"}
                                 :h4                  {:fontSize   "1.25rem"
                                                       :fontWeight "bold"}
                                 :h5                  {:fontSize   "1.18rem"
                                                       :fontWeight "bold"}
                                 :h6                  {:fontSize   "1rem"
                                                       :fontWeight "bold"}
                                 :p                   {:fontSize "0.9rem"}
                                 :a                   {:textDecoration "underline"
                                                       :fontFamily     "Source Sans Pro"
                                                       :fontWeight     "bold"}
                                 :li                  {:fontSize "0.9rem"}

                                 :service-title       {:fontSize        "1rem"
                                                       :fontWeight      "bold"
                                                       :color           "var(--color-service-title-text)"
                                                       :backgroundColor "var(--color-service-title-bg)"
                                                       :display         "block"
                                                       :height          "calc(100% - 6px)"
                                                       :padding         "4px 5px 2px 7px"
                                                       }

                                 :service-slot        {
                                                       }

                                 :service-description {:fontSize          "0.8rem"
                                                       :display           "block"
                                                       :color             "var(--color-text)"
                                                       :border            "1px solid var(--red-border)"
                                                       :borderTopWidth    "0" ;
                                                       :borderBottomWidth "0" ;
                                                       :padding           "3px 5px 2px 7px"}

                                 :service-additional  {:fontSize       "0.8rem"
                                                       :display        "block"
                                                       :color          "var(--color-text)"
                                                       :border         "1px solid var(--red-border)"
                                                       :borderCollapse "collapse"
                                                       :padding        "3px 5px 2px 7px"}
                                 }
                  }
                 )))